/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getWeights } from 'app/entities/weight/weight.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './paediatric-params.reducer';

export const PaediatricParamsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const weights = useAppSelector(state => state.weight.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const paediatricParamsEntity = useAppSelector(state => state.paediatricParams.entity);
  const loading = useAppSelector(state => state.paediatricParams.loading);
  const updating = useAppSelector(state => state.paediatricParams.updating);
  const updateSuccess = useAppSelector(state => state.paediatricParams.updateSuccess);

  const handleClose = () => {
    navigate(`/paediatric-params${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getWeights({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.headCircumference !== undefined && typeof values.headCircumference !== 'number') {
      values.headCircumference = Number(values.headCircumference);
    }
    if (values.midArmCircumference !== undefined && typeof values.midArmCircumference !== 'number') {
      values.midArmCircumference = Number(values.midArmCircumference);
    }
    if (values.thumbGirth !== undefined && typeof values.thumbGirth !== 'number') {
      values.thumbGirth = Number(values.thumbGirth);
    }
    if (values.thumbLength !== undefined && typeof values.thumbLength !== 'number') {
      values.thumbLength = Number(values.thumbLength);
    }
    if (values.thumbNailWidth !== undefined && typeof values.thumbNailWidth !== 'number') {
      values.thumbNailWidth = Number(values.thumbNailWidth);
    }
    if (values.subscapularSkinfold !== undefined && typeof values.subscapularSkinfold !== 'number') {
      values.subscapularSkinfold = Number(values.subscapularSkinfold);
    }
    if (values.tricepsSkinfold !== undefined && typeof values.tricepsSkinfold !== 'number') {
      values.tricepsSkinfold = Number(values.tricepsSkinfold);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...paediatricParamsEntity,
      ...values,
      weight: weights.find(it => it.id.toString() === values.weight?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...paediatricParamsEntity,
          weight: paediatricParamsEntity?.weight?.id,
          patient: paediatricParamsEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paediatricParams.home.createOrEditLabel" data-cy="PaediatricParamsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paediatricParams.home.createOrEditLabel">Create or edit a PaediatricParams</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="paediatric-params-id"
                  label={translate('tinyMedicRestApp.paediatricParams.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.headCircumference')}
                id="paediatric-params-headCircumference"
                name="headCircumference"
                data-cy="headCircumference"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.midArmCircumference')}
                id="paediatric-params-midArmCircumference"
                name="midArmCircumference"
                data-cy="midArmCircumference"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.thumbGirth')}
                id="paediatric-params-thumbGirth"
                name="thumbGirth"
                data-cy="thumbGirth"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.thumbLength')}
                id="paediatric-params-thumbLength"
                name="thumbLength"
                data-cy="thumbLength"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.thumbNailWidth')}
                id="paediatric-params-thumbNailWidth"
                name="thumbNailWidth"
                data-cy="thumbNailWidth"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.subscapularSkinfold')}
                id="paediatric-params-subscapularSkinfold"
                name="subscapularSkinfold"
                data-cy="subscapularSkinfold"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.tricepsSkinfold')}
                id="paediatric-params-tricepsSkinfold"
                name="tricepsSkinfold"
                data-cy="tricepsSkinfold"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.notes')}
                id="paediatric-params-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.active')}
                id="paediatric-params-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.timestampentry')}
                id="paediatric-params-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.microSec')}
                id="paediatric-params-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.lastupdated')}
                id="paediatric-params-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paediatricParams.cursor')}
                id="paediatric-params-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="paediatric-params-weight"
                name="weight"
                data-cy="weight"
                label={translate('tinyMedicRestApp.paediatricParams.weight')}
                type="select"
                required
              >
                <option value="" key="0" />
                {weights
                  ? weights.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="paediatric-params-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.paediatricParams.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/paediatric-params" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PaediatricParamsUpdate;
